import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './property-search/app.jsx';

export default class PropertySearch {
  constructor() {
    this.mapboxToken = window.MB_TOKEN || '';
    this.reactContainer = document.getElementById('property-search-react');

    this.renderSearchApp();
  }

  renderSearchApp() {
    if (!this.reactContainer) {
      return;
    }

    const root = createRoot(this.reactContainer);

    let appData = {};
    const dataScript = document.getElementById('property-search-data');
    if (dataScript) {
      try {
        appData = JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Failed to parse property-search-data JSON', e);
      }
    }

    root.render(
      React.createElement(
        BrowserRouter,
        null,
        React.createElement(App, appData),
      ),
    );
  }
}

new PropertySearch();
